import React, { useContext } from 'react';
import { compose } from 'redux';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-shared-react/pkg/Context';
import { ShopItemType } from '../../../../../types/shop';
import withSectionFetchSpinner from '../../../../decorators/withSectionFetchSpinner';
import ShopGrid from '../ShopGrid';
import PremiumFolderCreateButton from '../_partials/PremiumFolderCreateButton';
import PremiumFoldersEmptyState from '../_partials/PremiumFoldersEmptyState';
import { isCurrentUserProfileOwner } from '../../../../selectors/users';

import commonStyles from '../ShopSection.scss';
import s from './ShopPremiumFolders.scss';

export interface Props {
  className?: string;
}

const enhance = compose(withSectionFetchSpinner);

export const ShopPremiumFolders: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const isOwner = useSelector(isCurrentUserProfileOwner);

  return (
    <div className={commonStyles['section-with-no-header']}>
      {isOwner && !isMobile && <PremiumFolderCreateButton className={s['create-button']} />}
      <ShopGrid
        className={className}
        itemType={ShopItemType.PREMIUM_FOLDERS}
        duperbrowseTitle={t('common.shop')}
        emptyState={<PremiumFoldersEmptyState view={'large'} />}
      />
    </div>
  );
};
ShopPremiumFolders.displayName = 'ShopPremiumFolders';

export default enhance(ShopPremiumFolders) as React.ComponentType<Props>;
